<template>
  <div
    class="flex items-center space-x-1"
    :class="[getVariantClass, getSize, getColorClass]"
  >
    <fa
      v-if="hasIcon"
      :icon="icon"
      :class="[getIconColor]"
    />
    <div v-if="hasLabel">
      {{ label }}
    </div>
  </div>
</template>

<script>
import size from 'lodash/size';

export default {
  name: 'VetsterBadge',

  props: {
    size: {
      type: String,
      default: 'xs',
    },
    label: {
      type: String,
      default: () => '',
    },
    color: {
      type: String,
      default: 'blue',
    },
    variant: {
      type: String,
      default: 'solid',
    },
    icon: {
      type: Array,
      default: () => [],
    },
  },

  computed: {
    hasIcon() {
      return size(this.icon);
    },
    hasLabel() {
      return size(this.label);
    },
    getSize() {
      switch (this.size) {
        case 'lg':
          return 'text-lg';
        case 'base':
          return 'text-base';
        case 'sm':
          return 'text-sm';
        case 'xs':
          return 'text-xs';
        case 'xl':
        default:
          return 'text-xl';
      }
    },
    getColorClass() {
      switch (this.color) {
        case 'bubblegum':
          return 'bg-bubblegum-500 text-neutral-900 font-medium';
        case 'red':
          return 'text-red-500 bg-red-100 border-red-200';
        case 'orange':
          return 'text-orange-600 bg-orange-100 border-orange-200';
        case 'indigo':
          return 'text-indigo-600 bg-indigo-100 border-indigo-200';
        case 'pink':
          return 'text-pink-600 bg-pink-100 border-pink-200';
        case 'green':
          return 'text-green-600 bg-green-100 border-green-200';
        case 'gray':
        case 'neutral':
          return 'text-neutral-600 bg-neutral-100 border-neutral-200';
        case 'ocean':
          return 'text-white bg-ocean-800 border-ocean-900';
        case 'ocean-flip':
          return 'text-ocean-700 bg-white border-ocean-200';
        case 'blue':
        default:
          return 'text-blue-600 bg-blue-100 border-blue-200';
      }
    },
    getVariantClass() {
      switch (this.variant) {
        case 'pill':
          return 'rounded-full px-2.5 py-1 border';
        case 'tight':
          return 'rounded-full px-2.5 py-0.5';
        case 'solid':
        default:
          return 'rounded-md px-2 py-1 border-none';
      }
    },
    getIconColor() {
      switch (this.color) {
        case 'red':
          return 'text-red-500';
        case 'orange':
          return 'text-orange-600';
        case 'indigo':
          return 'text-indigo-600';
        case 'pink':
          return 'text-pink-600';
        case 'green':
          return 'text-green-600';
        case 'gray':
          return 'text-neutral-900';
        case 'ocean':
          return 'text-white';
        case 'ocean-flip':
          return 'text-ocean-700';
        case 'blue':
        default:
          return 'text-blue-600';
      }
    },
  },
};
</script>
